import type { Site } from '../Site';

export const Cucina: Site = {
  id: 'cucina',
  analyticsName: 'cucina',
  selector: '',
  logo: '',
  label: 'Cucina',
  platform: '',
};
